import { useEffect } from 'react';
import { connect } from 'react-redux';
import i18n from './config';

// Must match `supportedLngs` in i18n/config.js and API `locale` values (e.g. ja for Japanese).
const SUPPORTED = ['en', 'es', 'fr', 'de', 'ja'];

const pickLocale = (raw) => {
  if (!raw) return null;
  let l = String(raw).toLowerCase().trim();
  if (l.includes('-')) {
    [l] = l.split('-');
  }
  if (l.includes('_')) {
    [l] = l.split('_');
  }
  return SUPPORTED.includes(l) ? l : null;
};

/**
 * Applies `user.locale` from the API to i18next so `/locales/{lng}/` loads (e.g. `ja`).
 */
function I18nLanguageSync({ user }) {
  const userLocale = user && user.locale;

  useEffect(() => {
    const lang = pickLocale(userLocale);

    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [userLocale]);

  return null;
}

const mapStateToProps = state => ({
  user: state.user && state.user.user
});

export default connect(mapStateToProps)(I18nLanguageSync);
